export const aiVoiceSyllabus = {
  title: "AI Voice Model Trainer & Voiceover Artist – Master Certification",
  subtitle: "Comprehensive Professional Certification",
  description: "To pass this Certification Exam, candidates should have knowledge of the following topics:",
  sections: [
    {
      number: 1,
      title: "Foundations of Voice & Voiceover",
      items: [
        "Basics of human voice production and anatomy",
        "Voice modulation, tone, pitch, clarity, and diction",
        "Accent neutralization and pronunciation skills",
        "Breathing techniques and vocal warm-ups",
        "Microphone etiquette and voice discipline",
      ],
    },
    {
      number: 2,
      title: "Voiceover Performance Skills",
      items: [
        "Voice acting styles (commercial, narration, character, IVR, audiobooks)",
        "Script reading, interpretation, and emotional delivery",
        "Timing, pacing, pauses, and emphasis",
        "Multilingual voiceover basics (optional)",
        "Studio professionalism and client communication",
      ],
    },
    {
      number: 3,
      title: "Audio Recording & Studio Setup",
      items: [
        "Home studio setup (budget to professional)",
        "Microphones, audio interfaces, and accessories",
        "Recording environments and noise control",
        "Basic audio engineering concepts",
        "Recording best practices for AI datasets",
      ],
    },
    {
      number: 4,
      title: "Digital Audio Editing & Processing",
      items: [
        "Introduction to DAWs (Audacity / Adobe Audition / Reaper, etc.)",
        "Noise reduction, EQ, compression, and normalization",
        "Editing for clean voice datasets",
        "File formats, sample rates, and delivery standards",
        "Quality control for professional output",
      ],
    },
    {
      number: 5,
      title: "Introduction to AI Voice Technology",
      items: [
        "Overview of AI voice synthesis and cloning",
        "Text-to-Speech (TTS) vs Voice Modeling",
        "Understanding datasets and training pipelines",
        "Ethical use of AI voice technology",
        "Industry applications of AI voices",
      ],
    },
    {
      number: 6,
      title: "AI Voice Model Training",
      items: [
        "Voice data collection and preparation",
        "Dataset labeling and segmentation",
        "Training AI voice models (basic workflow)",
        "Testing, refining, and improving voice output",
        "Handling accents, emotions, and variations",
      ],
    },
    {
      number: 7,
      title: "Voice Data Optimization",
      items: [
        "Consistency and clarity in recordings",
        "Error detection and correction in datasets",
        "Improving realism and naturalness",
        "Managing multiple voice styles",
        "Voice model performance evaluation",
      ],
    },
    {
      number: 8,
      title: "Legal, Ethics & Copyright",
      items: [
        "Voice ownership and consent",
        "Copyright and licensing basics",
        "Ethical AI voice usage guidelines",
        "Commercial usage rights and contracts",
        "Client and platform compliance",
      ],
    },
    {
      number: 9,
      title: "Professional Branding & Career Setup",
      items: [
        "Freelancing platforms and marketplaces",
        "Pricing, negotiation, and project handling",
        "Career paths: Voice Artist, AI Trainer, Consultant",
      ],
    },
    {
      number: 10,
      title: "Practical Projects & Assessment",
      items: [
        "Live voice testing",
        "AI voice dataset creation project",
        "Voice model training mini-project",
      ],
    },
  ],
  gradingGuidelines: {
    title: "Grading & Marking Guidelines (Total: 100 Marks)",
    sections: [
      {
        number: 1,
        title: "Voice Quality & Control",
        marks: 20,
        description: "Clarity, tone, modulation, breath control",
      },
      {
        number: 2,
        title: "Voiceover Performance",
        marks: 20,
        description: "Expression, script interpretation, pacing",
      },
      {
        number: 3,
        title: "AI Voice Model Training Knowledge",
        marks: 20,
        description: "AI voice concepts, dataset handling, ethics",
      },
      {
        number: 4,
        title: "Technical & Audio Skills",
        marks: 15,
        description: "Recording quality, mic handling, basic editing",
      },
      {
        number: 5,
        title: "Script Reading & Language Skills",
        marks: 15,
        description: "Pronunciation, fluency, articulation",
      },
      {
        number: 6,
        title: "Professionalism & Industry Readiness",
        marks: 10,
        description: "Discipline, instructions, confirm readiness",
      },
    ],
    resultClassification: [
      { range: "85–100", grade: "Distinction", status: "Industry Ready" },
      { range: "70–84", grade: "First Class", status: "Certified" },
      { range: "50–69", grade: "Pass", status: "Certified" },
      { range: "Below 50", grade: "Fail", status: "Re-assessment Required" },
    ],
    notes: [
      "Practical exam has higher weightage",
      "Ethical misuse or plagiarism = disqualification",
    ],
  },
};
